import * as i0 from '@angular/core';
import { EventEmitter, Component, ViewChild, Input, Output, SecurityContext, PLATFORM_ID, forwardRef, Inject, Attribute, NgModule } from '@angular/core';
import * as i2 from '@angular/common';
import { isPlatformBrowser, CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormsModule } from '@angular/forms';
import { Subject } from 'rxjs';
import * as i1 from '@angular/platform-browser';
const _c0 = ["resizeSensor"];
const _c1 = ["aceEditor"];
const _c2 = ["previewContainer"];
const _c3 = [[["", "custom-btns", ""]]];
const _c4 = ["[custom-btns]"];
function MarkdownEditorComponent_div_2_button_2_Template(rf, ctx) {
  if (rf & 1) {
    const _r2 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function MarkdownEditorComponent_div_2_button_2_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r2);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.insertContent("Bold"));
    });
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("title", ctx_r2.buttonText.Bold.title);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2.options.customIcons.Bold.fontClass);
  }
}
function MarkdownEditorComponent_div_2_button_3_Template(rf, ctx) {
  if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function MarkdownEditorComponent_div_2_button_3_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r4);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.insertContent("Italic"));
    });
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("title", ctx_r2.buttonText.Italic.title);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2.options.customIcons.Italic.fontClass);
  }
}
function MarkdownEditorComponent_div_2_button_4_Template(rf, ctx) {
  if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function MarkdownEditorComponent_div_2_button_4_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r5);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.insertContent("Heading"));
    });
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("title", ctx_r2.buttonText.Heading.title);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2.options.customIcons.Heading.fontClass);
  }
}
function MarkdownEditorComponent_div_2_button_5_Template(rf, ctx) {
  if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function MarkdownEditorComponent_div_2_button_5_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r6);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.insertContent("Reference"));
    });
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("title", ctx_r2.buttonText.Reference.title);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2.options.customIcons.Reference.fontClass);
  }
}
function MarkdownEditorComponent_div_2_button_7_Template(rf, ctx) {
  if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function MarkdownEditorComponent_div_2_button_7_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r7);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.insertContent("Link"));
    });
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("title", ctx_r2.buttonText.Link.title);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2.options.customIcons.Link.fontClass);
  }
}
function MarkdownEditorComponent_div_2_button_8_Template(rf, ctx) {
  if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function MarkdownEditorComponent_div_2_button_8_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r8);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.insertContent("Image"));
    });
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("title", ctx_r2.buttonText.Image.title);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2.options.customIcons.Image.fontClass);
  }
}
function MarkdownEditorComponent_div_2_button_10_Template(rf, ctx) {
  if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function MarkdownEditorComponent_div_2_button_10_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r9);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.insertContent("Ul"));
    });
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("title", ctx_r2.buttonText.UnorderedList.title);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2.options.customIcons.UnorderedList.fontClass);
  }
}
function MarkdownEditorComponent_div_2_button_11_Template(rf, ctx) {
  if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function MarkdownEditorComponent_div_2_button_11_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r10);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.insertContent("Ol"));
    });
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("title", ctx_r2.buttonText.OrderedList.title);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2.options.customIcons.OrderedList.fontClass);
  }
}
function MarkdownEditorComponent_div_2_button_12_Template(rf, ctx) {
  if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function MarkdownEditorComponent_div_2_button_12_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r11);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.insertContent("Code"));
    });
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("title", ctx_r2.buttonText.CodeBlock.title);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2.options.customIcons.CodeBlock.fontClass);
  }
}
function MarkdownEditorComponent_div_2_button_14_Template(rf, ctx) {
  if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function MarkdownEditorComponent_div_2_button_14_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r12);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.togglePreview());
    });
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵattribute("title", ctx_r2.showPreviewPanel ? ctx_r2.buttonText.HidePreview.title : ctx_r2.buttonText.ShowPreview.title);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2.showPreviewPanel ? ctx_r2.options.customIcons.ShowPreview.fontClass : ctx_r2.options.customIcons.HidePreview.fontClass);
  }
}
function MarkdownEditorComponent_div_2_button_18_Template(rf, ctx) {
  if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 19);
    i0.ɵɵlistener("click", function MarkdownEditorComponent_div_2_button_18_Template_button_click_0_listener() {
      i0.ɵɵrestoreView(_r13);
      const ctx_r2 = i0.ɵɵnextContext(2);
      return i0.ɵɵresetView(ctx_r2.fullScreen());
    });
    i0.ɵɵelement(1, "i");
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext(2);
    i0.ɵɵclassProp("active", ctx_r2.isFullScreen);
    i0.ɵɵattribute("title", ctx_r2.buttonText.Fullscreen.title);
    i0.ɵɵadvance();
    i0.ɵɵclassMap(ctx_r2.options.customIcons.FullScreen.fontClass);
  }
}
function MarkdownEditorComponent_div_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 14)(1, "div", 15);
    i0.ɵɵtemplate(2, MarkdownEditorComponent_div_2_button_2_Template, 2, 3, "button", 16)(3, MarkdownEditorComponent_div_2_button_3_Template, 2, 3, "button", 16)(4, MarkdownEditorComponent_div_2_button_4_Template, 2, 3, "button", 16)(5, MarkdownEditorComponent_div_2_button_5_Template, 2, 3, "button", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "div", 15);
    i0.ɵɵtemplate(7, MarkdownEditorComponent_div_2_button_7_Template, 2, 3, "button", 16)(8, MarkdownEditorComponent_div_2_button_8_Template, 2, 3, "button", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 15);
    i0.ɵɵtemplate(10, MarkdownEditorComponent_div_2_button_10_Template, 2, 3, "button", 16)(11, MarkdownEditorComponent_div_2_button_11_Template, 2, 3, "button", 16)(12, MarkdownEditorComponent_div_2_button_12_Template, 2, 3, "button", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 15);
    i0.ɵɵtemplate(14, MarkdownEditorComponent_div_2_button_14_Template, 2, 3, "button", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 15);
    i0.ɵɵprojection(16);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 17);
    i0.ɵɵtemplate(18, MarkdownEditorComponent_div_2_button_18_Template, 2, 5, "button", 18);
    i0.ɵɵelementEnd()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.hideIcons.Bold);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.hideIcons.Italic);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.hideIcons.Heading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.hideIcons.Reference);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.hideIcons.Link);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.hideIcons.Image);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.hideIcons.Ul);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.hideIcons.Ol);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r2.hideIcons.Code);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.hideIcons.TogglePreview);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", !ctx_r2.hideIcons.FullScreen);
  }
}
function MarkdownEditorComponent_div_5__svg_svg_2_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 25);
    i0.ɵɵelement(1, "path", 26);
    i0.ɵɵelementEnd();
  }
}
function MarkdownEditorComponent_div_5_div_3_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelement(0, "div", 27);
  }
}
function MarkdownEditorComponent_div_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 20)(1, "div", 21);
    i0.ɵɵtemplate(2, MarkdownEditorComponent_div_5__svg_svg_2_Template, 2, 0, "svg", 22)(3, MarkdownEditorComponent_div_5_div_3_Template, 1, 0, "div", 23);
    i0.ɵɵelementStart(4, "div", 24);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()()();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r2.isUploading);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r2.isUploading);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r2.isUploading ? ctx_r2.uploadText.Uploading : ctx_r2.uploadText.Drag);
  }
}
function MarkdownEditorComponent_div_12_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 28)(1, "div", 29);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "div", 30);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2(" ", ctx_r2.markdownValue == null ? null : ctx_r2.markdownValue.length, " / ", ctx_r2.maxlength, " ");
  }
}
function MarkdownEditorComponent_md_editor_resize_sensor_13_Template(rf, ctx) {
  if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "md-editor-resize-sensor", 31);
    i0.ɵɵlistener("resize", function MarkdownEditorComponent_md_editor_resize_sensor_13_Template_md_editor_resize_sensor_resize_0_listener($event) {
      i0.ɵɵrestoreView(_r14);
      const ctx_r2 = i0.ɵɵnextContext();
      return i0.ɵɵresetView(ctx_r2.mdEditorResize($event));
    });
    i0.ɵɵelementEnd();
  }
}
const DEFAULT_LOCALES = {
  en: {
    Buttons: {
      Bold: {
        title: 'Bold',
        initText: 'Bold Text'
      },
      Italic: {
        title: 'Italic',
        initText: 'Italic Text'
      },
      Heading: {
        title: 'Heading'
      },
      Reference: {
        title: 'Reference'
      },
      Link: {
        title: 'Link'
      },
      Image: {
        title: 'Image'
      },
      UnorderedList: {
        title: 'Unordered List',
        initText: ''
      },
      OrderedList: {
        title: 'Ordered List',
        initText: ''
      },
      CodeBlock: {
        title: 'Code Block',
        initText: 'Source Code'
      },
      ShowPreview: {
        title: 'Show Preview'
      },
      HidePreview: {
        title: 'Hide Preview'
      },
      Fullscreen: {
        title: 'Fullscreen'
      }
    },
    Upload: {
      Drag: 'Drag it here',
      Uploading: 'Uploading'
    }
  }
};
const DEFAULT_ICONS = {
  fontAwesome4: {
    Bold: {
      fontClass: 'fa fa-bold'
    },
    Italic: {
      fontClass: 'fa fa-italic'
    },
    Heading: {
      fontClass: 'fa fa-header'
    },
    Reference: {
      fontClass: 'fa fa-quote-left'
    },
    Link: {
      fontClass: 'fa fa-link'
    },
    Image: {
      fontClass: 'fa fa-image'
    },
    UnorderedList: {
      fontClass: 'fa fa-list-ul'
    },
    OrderedList: {
      fontClass: 'fa fa-list-ol'
    },
    CodeBlock: {
      fontClass: 'fa fa-file-code-o'
    },
    ShowPreview: {
      fontClass: 'fa fa-eye'
    },
    HidePreview: {
      fontClass: 'fa fa-eye-slash'
    },
    FullScreen: {
      fontClass: 'fa fa-arrows-alt'
    },
    CheckBox_UnChecked: {
      fontClass: 'fa fa-square-o'
    },
    CheckBox_Checked: {
      fontClass: 'fa fa-check-square'
    }
  },
  fontAwesome5: {
    Bold: {
      fontClass: 'fas fa-bold'
    },
    Italic: {
      fontClass: 'fas fa-italic'
    },
    Heading: {
      fontClass: 'fas fa-heading'
    },
    Reference: {
      fontClass: 'fas fa-quote-left'
    },
    Link: {
      fontClass: 'fas fa-link'
    },
    Image: {
      fontClass: 'fas fa-image'
    },
    UnorderedList: {
      fontClass: 'fas fa-list-ul'
    },
    OrderedList: {
      fontClass: 'fas fa-list-ol'
    },
    CodeBlock: {
      fontClass: 'fas fa-file-code'
    },
    ShowPreview: {
      fontClass: 'fas fa-eye'
    },
    HidePreview: {
      fontClass: 'fas fa-eye-slash'
    },
    FullScreen: {
      fontClass: 'fas fa-compress'
    },
    CheckBox_UnChecked: {
      fontClass: 'far fa-square'
    },
    CheckBox_Checked: {
      fontClass: 'fas fa-check-square'
    }
  },
  fontAwesome6: {
    Bold: {
      fontClass: 'fa-solid fa-bold'
    },
    Italic: {
      fontClass: 'fa-solid fa-italic'
    },
    Heading: {
      fontClass: 'fa-solid fa-heading'
    },
    Reference: {
      fontClass: 'fa-solid fa-quote-left'
    },
    Link: {
      fontClass: 'fa-solid fa-link'
    },
    Image: {
      fontClass: 'fa-solid fa-image'
    },
    UnorderedList: {
      fontClass: 'fa-solid fa-list-ul'
    },
    OrderedList: {
      fontClass: 'fa-solid fa-list-ol'
    },
    CodeBlock: {
      fontClass: 'fa-solid fa-file-code'
    },
    ShowPreview: {
      fontClass: 'fa-solid fa-eye'
    },
    HidePreview: {
      fontClass: 'fa-solid fa-eye-slash'
    },
    FullScreen: {
      fontClass: 'fa-solid fa-maximize'
    },
    CheckBox_UnChecked: {
      fontClass: 'fa-regular fa-square'
    },
    CheckBox_Checked: {
      fontClass: 'fa-solid fa-check-square'
    }
  }
};
let MarkdownEditorResizeSensorComponent = /*#__PURE__*/(() => {
  class MarkdownEditorResizeSensorComponent {
    constructor(_ngZone) {
      this._ngZone = _ngZone;
      this.interval = 500;
      this.resize = new EventEmitter();
      this.sizeInfo = {
        width: 0,
        height: 0
      };
    }
    ngAfterViewInit() {
      this.sizeInfo = {
        width: this.resizeSensor.nativeElement.offsetWidth,
        height: this.resizeSensor.nativeElement.offsetHeight
      };
      this._ngZone.runOutsideAngular(() => {
        setTimeout(() => {
          this.detectSize();
        }, this.interval);
      });
    }
    detectSize() {
      let width = this.resizeSensor.nativeElement.offsetWidth;
      let height = this.resizeSensor.nativeElement.offsetHeight;
      if (this.sizeInfo.width !== width || this.sizeInfo.height !== height) {
        this.sizeInfo = {
          width: width,
          height: height
        };
        this.resize.emit(this.sizeInfo);
      }
      setTimeout(() => {
        this.detectSize();
      }, this.interval);
    }
  }
  MarkdownEditorResizeSensorComponent.ɵfac = function MarkdownEditorResizeSensorComponent_Factory(t) {
    return new (t || MarkdownEditorResizeSensorComponent)(i0.ɵɵdirectiveInject(i0.NgZone));
  };
  MarkdownEditorResizeSensorComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MarkdownEditorResizeSensorComponent,
    selectors: [["md-editor-resize-sensor"]],
    viewQuery: function MarkdownEditorResizeSensorComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.resizeSensor = _t.first);
      }
    },
    inputs: {
      interval: "interval"
    },
    outputs: {
      resize: "resize"
    },
    decls: 2,
    vars: 0,
    consts: [["resizeSensor", ""], [1, "md-editor-resize-sensor"]],
    template: function MarkdownEditorResizeSensorComponent_Template(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵelement(0, "div", 1, 0);
      }
    },
    styles: [".md-editor-resize-sensor[_ngcontent-%COMP%]{position:absolute;inset:0;z-index:-1}"]
  });
  return MarkdownEditorResizeSensorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
const DEFAULT_EDITOR_OPTION = {
  showPreviewPanel: true,
  showBorder: true,
  hideIcons: [],
  usingFontAwesome5: false,
  scrollPastEnd: 0,
  enablePreviewContentClick: false,
  resizable: false,
  customIcons: DEFAULT_ICONS.fontAwesome4,
  locales: DEFAULT_LOCALES,
  placeholder: ''
};
let MarkdownEditorComponent = /*#__PURE__*/(() => {
  class MarkdownEditorComponent {
    constructor(platform, required = false, _ngZone, _renderer2, _domSanitizer) {
      this.platform = platform;
      this.required = required;
      this._ngZone = _ngZone;
      this._renderer2 = _renderer2;
      this._domSanitizer = _domSanitizer;
      this.hideToolbar = false;
      this.height = "300px";
      this._locale = 'en';
      this._maxlength = -1;
      this._mode = 'editor';
      this._options = Object.assign({}, DEFAULT_EDITOR_OPTION);
      this.onEditorLoaded = new EventEmitter();
      this.onPreviewDomChanged = new EventEmitter();
      this.hideIcons = {};
      this.showPreviewPanel = true;
      this.isFullScreen = false;
      this.dragover = false;
      this.isUploading = false;
      this.valueChanges = new Subject();
      this._onChange = _ => {};
      this._onTouched = () => {};
    }
    get locale() {
      return this._locale || 'en';
    }
    set locale(val) {
      this._locale = val;
    }
    get maxlength() {
      return this._maxlength;
    }
    set maxlength(val) {
      if (!Number.isInteger(val)) val = parseInt(val, 10);
      if (Number.isInteger(val)) this._maxlength = val;
    }
    get mode() {
      return this._mode;
    }
    set mode(value) {
      this._mode = !value || ['editor', 'preview'].indexOf(value.toLowerCase()) === -1 ? 'editor' : value;
      setTimeout(() => {
        if (this._aceEditorIns && typeof this._aceEditorIns.resize === 'function') {
          this._aceEditorIns.resize();
        }
      }, 100);
    }
    get options() {
      return this._options;
    }
    set options(value) {
      const options = Object.assign({}, DEFAULT_EDITOR_OPTION, value);
      let defaultIcons = DEFAULT_ICONS.fontAwesome4;
      if (value.fontAwesomeVersion && ['4', '5', '6'].indexOf(value.fontAwesomeVersion.toString()) !== -1) {
        defaultIcons = DEFAULT_ICONS[`fontAwesome${value.fontAwesomeVersion}`];
      } else if (value.usingFontAwesome5) {
        defaultIcons = DEFAULT_ICONS.fontAwesome5;
      }
      if (typeof options.showPreviewPanel === 'boolean') {
        this.showPreviewPanel = options.showPreviewPanel;
      }
      options.customIcons = Object.assign({}, defaultIcons, value.customIcons);
      const hideIcons = {};
      if (Array.isArray(options.hideIcons)) {
        options.hideIcons.forEach(v => {
          if (v === 'Refrence') v = 'Reference';
          hideIcons[v] = true;
        });
      }
      this.hideIcons = hideIcons;
      options.locales = Object.assign({}, DEFAULT_LOCALES, value.locales);
      this._options = options;
      if (this._aceEditorIns) this._aceEditorIns.setOption('placeholder', this.options.placeholder || '');
    }
    get localeText() {
      const r = Object.assign({}, DEFAULT_LOCALES[this.locale], this.options.locales[this.locale]);
      return Object.assign({}, DEFAULT_LOCALES.en, r);
    }
    get buttonText() {
      return this.localeText.Buttons;
    }
    get uploadText() {
      return this.localeText.Upload;
    }
    //#region Markdown value and html value define
    get markdownValue() {
      return this._markdownValue || '';
    }
    set markdownValue(value) {
      this._markdownValue = value || '';
      this.valueChanges.next(this.markdownValue);
    }
    get _hasUploadFunction() {
      return this.upload && this.upload instanceof Function;
    }
    get _isInBrowser() {
      return isPlatformBrowser(this.platform);
    }
    ngOnInit() {
      if (!this._isInBrowser) return;
      let markedRender = new marked.Renderer();
      markedRender.image = this._getRender('image');
      markedRender.code = this._getRender('code');
      markedRender.table = this._getRender('table');
      markedRender.listitem = this._getRender('listitem');
      let markedjsOpt = {
        renderer: markedRender,
        highlight: code => hljs.highlightAuto(code).value
      };
      this._markedJsOpt = Object.assign({}, markedjsOpt, this.options.markedjsOpt);
      if (this._markedJsOpt.sanitize === true && typeof this._markedJsOpt.sanitizer !== 'function') {
        this._markedJsOpt.sanitizer = markdownString => {
          return this._domSanitizer.sanitize(SecurityContext.HTML, markdownString);
        };
      }
    }
    ngAfterViewInit() {
      if (!this._isInBrowser) return;
      let editorElement = this.aceEditorContainer.nativeElement;
      let editor = ace.edit(editorElement);
      editor.$blockScrolling = Infinity;
      editor.getSession().setUseWrapMode(true);
      editor.getSession().setMode("ace/mode/markdown");
      editor.setValue(this.markdownValue, 1);
      editor.setOption('scrollPastEnd', this._options.scrollPastEnd || 0);
      editor.on('change', e => {
        if (this._isValueSettedByprogrammatically) return;
        let val = editor.getValue();
        this._updateMarkdownValue(val, true);
        this._onChange(this.markdownValue);
      });
      editor.on('blur', () => {
        this._onTouched();
      });
      editor.setOption('placeholder', this.options.placeholder || '');
      this.onEditorLoaded.next(editor);
      this._aceEditorIns = editor;
    }
    ngOnDestroy() {
      this._aceEditorIns && this._aceEditorIns.destroy();
      this.valueChanges && this.valueChanges.complete();
    }
    writeValue(value) {
      this._updateMarkdownValue(value, false);
    }
    registerOnChange(fn) {
      this._onChange = fn;
    }
    registerOnTouched(fn) {
      this._onTouched = fn;
    }
    validate(c) {
      let result = null;
      if (this.required && this.markdownValue.length === 0) {
        result = {
          required: true
        };
      }
      if (this.maxlength > 0 && this.markdownValue.length > this.maxlength) {
        result = {
          maxlength: true
        };
      }
      return result;
    }
    insertContent(type, customContent) {
      if (!this._aceEditorIns) return;
      let selectedText = this._aceEditorIns.getSelectedText();
      let isSelected = !!selectedText;
      let startSize = 2;
      let initText = '';
      let range = this._aceEditorIns.selection.getRange();
      switch (type) {
        case 'Bold':
          initText = this.buttonText.Bold.initText ?? this.buttonText.Bold.title;
          selectedText = `**${selectedText || initText}**`;
          break;
        case 'Italic':
          initText = this.buttonText.Italic.initText ?? this.buttonText.Italic.title;
          selectedText = `*${selectedText || initText}*`;
          startSize = 1;
          break;
        case 'Heading':
          initText = this.buttonText.Heading.initText ?? this.buttonText.Heading.title;
          selectedText = `# ${selectedText || initText}`;
          break;
        case 'Reference':
          initText = this.buttonText.Reference.initText ?? this.buttonText.Reference.title;
          selectedText = `> ${selectedText || initText}`;
          break;
        case 'Link':
          selectedText = `[](http://)`;
          startSize = 1;
          break;
        case 'Image':
          selectedText = `![](http://)`;
          break;
        case 'Ul':
          initText = this.buttonText.UnorderedList.initText ?? this.buttonText.UnorderedList.title;
          selectedText = `- ${selectedText || initText}`;
          break;
        case 'Ol':
          initText = this.buttonText.OrderedList.initText ?? this.buttonText.OrderedList.title;
          selectedText = `1. ${selectedText || initText}`;
          startSize = 3;
          break;
        case 'Code':
          initText = this.buttonText.CodeBlock.initText ?? this.buttonText.CodeBlock.title;
          selectedText = "```language\r\n" + (selectedText || initText) + "\r\n```";
          startSize = 3;
          break;
        case 'Custom':
          selectedText = customContent;
          startSize = 0;
          break;
      }
      this._aceEditorIns.session.replace(range, selectedText);
      if (!isSelected) {
        range.start.column += startSize;
        range.end.column = range.start.column + initText.length;
        this._aceEditorIns.selection.setRange(range);
      }
      this._aceEditorIns.focus();
    }
    togglePreview() {
      this.showPreviewPanel = !this.showPreviewPanel;
      this.editorResize();
    }
    previewPanelClick(event) {
      if (this.options.enablePreviewContentClick !== true) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }
    fullScreen() {
      this.isFullScreen = !this.isFullScreen;
      this._renderer2.setStyle(document.body, 'overflowY', this.isFullScreen ? 'hidden' : 'auto');
      this.editorResize();
    }
    mdEditorResize(size) {
      this.editorResize();
    }
    editorResize(timeOut = 100) {
      if (!this._aceEditorIns) return;
      if (this._aceEditorResizeTimer) clearTimeout(this._aceEditorResizeTimer);
      this._aceEditorResizeTimer = setTimeout(() => {
        this._aceEditorIns.resize();
        this._aceEditorIns.focus();
      }, timeOut);
    }
    onDragover(evt) {
      evt.stopImmediatePropagation();
      evt.preventDefault();
      if (!this._hasUploadFunction) return;
      this.dragover = true;
    }
    onDrop(evt) {
      evt.stopImmediatePropagation();
      evt.preventDefault();
      this._uploadFiles(evt.dataTransfer.files);
    }
    onDragleave(evt) {
      evt.stopImmediatePropagation();
      evt.preventDefault();
      this.dragover = false;
      if (!this._hasUploadFunction) return;
    }
    onAceEditorPaste(event) {
      if (event instanceof ClipboardEvent && event.clipboardData.files.length > 0) {
        this._uploadFiles(event.clipboardData.files);
      }
    }
    _updateMarkdownValue(value, changedByUser = false) {
      const normalizedValue = typeof value === 'string' ? value : (value || '').toString();
      if (this.markdownValue === normalizedValue) return;
      this.markdownValue = normalizedValue;
      this._updateDom();
      if (this._aceEditorIns && !changedByUser) {
        this._isValueSettedByprogrammatically = true;
        this._aceEditorIns.setValue(normalizedValue, 1);
        this._isValueSettedByprogrammatically = false;
      }
    }
    _updateDom() {
      if (this._convertMarkdownToHtmlTimer) clearTimeout(this._convertMarkdownToHtmlTimer);
      this._convertMarkdownToHtmlTimer = setTimeout(() => {
        Promise.resolve(this.markdownValue).then(mdContent => {
          return this.preRender && this.preRender instanceof Function ? this.preRender(mdContent) : mdContent;
        }).then(mdContent => {
          let html = marked(mdContent || '', this._markedJsOpt);
          return this.postRender && this.postRender instanceof Function ? this.postRender(html) : html;
        }).then(parsedHtml => {
          this.previewHtml = this._domSanitizer.bypassSecurityTrustHtml(parsedHtml);
          if (this.previewContainer && this.previewContainer.nativeElement) {
            this._ngZone.runOutsideAngular(() => {
              this._renderer2.setProperty(this.previewContainer.nativeElement, 'innerHTML', parsedHtml);
              setTimeout(() => {
                this.onPreviewDomChanged.next(this.previewContainer.nativeElement);
              }, 100);
            });
          }
        }).catch(err => {
          console.error(err);
        });
      }, 100);
    }
    _getRender(renderType) {
      let customRender = this.options && this.options.customRender && this.options.customRender[renderType];
      if (customRender && typeof customRender === 'function') {
        return customRender;
      } else {
        switch (renderType) {
          case 'image':
            return function (href, title, text) {
              let out = `<img style="max-width: 100%;" src="${href}" alt="${text}"`;
              if (title) {
                out += ` title="${title}"`;
              }
              out += this.options.xhtml ? "/>" : ">";
              return out;
            };
          case 'code':
            return function (code, language) {
              let validLang = !!(language && hljs.getLanguage(language));
              let highlighted = '';
              if (validLang) {
                highlighted = hljs.highlight(language, code).value;
              } else {
                let pre = document.createElement('pre');
                pre.innerText = code;
                highlighted = pre.innerHTML;
              }
              return `<pre style="padding: 0; border-radius: 0;"><code class="hljs ${language}">${highlighted}</code></pre>`;
            };
          case 'table':
            return function (header, body) {
              return `<table class="table table-bordered">\n<thead>\n${header}</thead>\n<tbody>\n${body}</tbody>\n</table>\n`;
            };
          case 'listitem':
            const checkedCheckbox = `<i class="${this.options.customIcons.CheckBox_Checked.fontClass}"></i> `,
              unCheckedCheckbox = `<i class="${this.options.customIcons.CheckBox_UnChecked.fontClass}"></i> `;
            return function (text, task, checked) {
              if (/^\s*\[[x ]\]\s*/.test(text) || text.startsWith('<input')) {
                if (text.startsWith('<input')) {
                  text = text.replace('<input disabled="" type="checkbox">', unCheckedCheckbox).replace('<input checked="" disabled="" type="checkbox">', checkedCheckbox);
                } else {
                  text = text.replace(/^\s*\[ \]\s*/, unCheckedCheckbox).replace(/^\s*\[x\]\s*/, checkedCheckbox);
                }
                return `<li>${text}</li>`;
              } else {
                return `<li>${text}</li>`;
              }
            };
        }
      }
    }
    _uploadFiles(files) {
      if (!this._hasUploadFunction || this.isUploading) return;
      if (!files || files.length === 0) {
        this.dragover = false;
        return;
      }
      this.isUploading = true;
      // force dragover to be true, as Uploading mask won't work otherwise
      this.dragover = true;
      Promise.resolve().then(() => {
        return this.upload(files);
      }).then(data => {
        if (Array.isArray(data)) {
          let msg = [];
          for (let item of data) {
            let tempMsg = `[${item.name}](${item.url})`;
            if (item.isImg) {
              tempMsg = `!${tempMsg}`;
            }
            msg.push(tempMsg);
          }
          const range = this._aceEditorIns.selection.getRange();
          const newRange = {
            start: {
              column: 0,
              row: range.end.row + 1
            },
            end: {
              column: 0,
              row: range.end.row + 1
            }
          };
          this._aceEditorIns.session.replace(newRange, '\r\n');
          this._aceEditorIns.selection.setRange(newRange);
          this._aceEditorIns.focus();
          this.insertContent('Custom', msg.join('\r\n'));
        } else {
          console.warn('Invalid upload result. Please using follow this type `UploadResult`.');
        }
        this.isUploading = false;
        this.dragover = false;
      }).catch(err => {
        console.error(err);
        this.isUploading = false;
        this.dragover = false;
      });
    }
  }
  MarkdownEditorComponent.ɵfac = function MarkdownEditorComponent_Factory(t) {
    return new (t || MarkdownEditorComponent)(i0.ɵɵdirectiveInject(PLATFORM_ID), i0.ɵɵinjectAttribute('required'), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i0.Renderer2), i0.ɵɵdirectiveInject(i1.DomSanitizer));
  };
  MarkdownEditorComponent.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
    type: MarkdownEditorComponent,
    selectors: [["md-editor"]],
    viewQuery: function MarkdownEditorComponent_Query(rf, ctx) {
      if (rf & 1) {
        i0.ɵɵviewQuery(_c1, 7);
        i0.ɵɵviewQuery(_c2, 7);
      }
      if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.aceEditorContainer = _t.first);
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.previewContainer = _t.first);
      }
    },
    inputs: {
      hideToolbar: "hideToolbar",
      height: "height",
      preRender: "preRender",
      postRender: "postRender",
      upload: "upload",
      locale: "locale",
      maxlength: "maxlength",
      mode: "mode",
      options: "options"
    },
    outputs: {
      onEditorLoaded: "onEditorLoaded",
      onPreviewDomChanged: "onPreviewDomChanged"
    },
    features: [i0.ɵɵProvidersFeature([{
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MarkdownEditorComponent),
      multi: true
    }, {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => MarkdownEditorComponent),
      multi: true
    }])],
    ngContentSelectors: _c4,
    decls: 14,
    vars: 16,
    consts: [["aceEditor", ""], ["previewContainer", ""], [1, "md-editor-container"], [1, "md-layout"], ["class", "tool-bar", 4, "ngIf"], [1, "editor-container"], [3, "dragover", "drop", "dragleave"], ["class", "drag-container", 4, "ngIf"], ["contenteditable", "true", 1, "editor-panel", 3, "paste"], [1, "ace-editor"], [1, "preview-container", 3, "click"], [1, "preview-panel"], ["class", "md-footer", 4, "ngIf"], [3, "resize", 4, "ngIf"], [1, "tool-bar"], [1, "btn-group"], ["class", "btn btn-sm btn-default", "type", "button", 3, "click", 4, "ngIf"], [1, "btn-group", "pull-right", "hide-split"], ["class", "btn btn-sm btn-default", "type", "button", 3, "active", "click", 4, "ngIf"], ["type", "button", 1, "btn", "btn-sm", "btn-default", 3, "click"], [1, "drag-container"], [1, "upload-loading"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 512 512", "fill", "#fff", 4, "ngIf"], ["class", "lds-dual-ring", 4, "ngIf"], [1, "text"], ["xmlns", "http://www.w3.org/2000/svg", "viewBox", "0 0 512 512", "fill", "#fff"], ["d", "M288 109.3V352c0 17.7-14.3 32-32 32s-32-14.3-32-32V109.3l-73.4 73.4c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l128-128c12.5-12.5 32.8-12.5 45.3 0l128 128c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L288 109.3zM64 352H192c0 35.3 28.7 64 64 64s64-28.7 64-64H448c35.3 0 64 28.7 64 64v32c0 35.3-28.7 64-64 64H64c-35.3 0-64-28.7-64-64V416c0-35.3 28.7-64 64-64zM432 456c13.3 0 24-10.7 24-24s-10.7-24-24-24s-24 10.7-24 24s10.7 24 24 24z"], [1, "lds-dual-ring"], [1, "md-footer"], [1, "text-right", "length-view"], [1, "resize-btn"], [3, "resize"]],
    template: function MarkdownEditorComponent_Template(rf, ctx) {
      if (rf & 1) {
        const _r1 = i0.ɵɵgetCurrentView();
        i0.ɵɵprojectionDef(_c3);
        i0.ɵɵelementStart(0, "div", 2)(1, "div", 3);
        i0.ɵɵtemplate(2, MarkdownEditorComponent_div_2_Template, 19, 11, "div", 4);
        i0.ɵɵelementStart(3, "div", 5)(4, "div", 6);
        i0.ɵɵlistener("dragover", function MarkdownEditorComponent_Template_div_dragover_4_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onDragover($event));
        })("drop", function MarkdownEditorComponent_Template_div_drop_4_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onDrop($event));
        })("dragleave", function MarkdownEditorComponent_Template_div_dragleave_4_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onDragleave($event));
        });
        i0.ɵɵtemplate(5, MarkdownEditorComponent_div_5_Template, 6, 3, "div", 7);
        i0.ɵɵelementStart(6, "div", 8);
        i0.ɵɵlistener("paste", function MarkdownEditorComponent_Template_div_paste_6_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.onAceEditorPaste($event));
        });
        i0.ɵɵelement(7, "div", 9, 0);
        i0.ɵɵelementEnd()();
        i0.ɵɵelementStart(9, "div", 10);
        i0.ɵɵlistener("click", function MarkdownEditorComponent_Template_div_click_9_listener($event) {
          i0.ɵɵrestoreView(_r1);
          return i0.ɵɵresetView(ctx.previewPanelClick($event));
        });
        i0.ɵɵelement(10, "div", 11, 1);
        i0.ɵɵelementEnd()();
        i0.ɵɵtemplate(12, MarkdownEditorComponent_div_12_Template, 4, 2, "div", 12);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(13, MarkdownEditorComponent_md_editor_resize_sensor_13_Template, 1, 0, "md-editor-resize-sensor", 13);
        i0.ɵɵelementEnd();
      }
      if (rf & 2) {
        i0.ɵɵstyleProp("height", ctx.height);
        i0.ɵɵclassProp("fullscreen", ctx.isFullScreen)("md-editor-resizable", ctx.options == null ? null : ctx.options.resizable);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("ngIf", !ctx.hideToolbar && ctx.mode != "preview");
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("display", ctx.mode == "preview" ? "none" : null);
        i0.ɵɵclassProp("dragover", ctx.dragover);
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.isUploading);
        i0.ɵɵadvance(4);
        i0.ɵɵstyleProp("display", ctx.mode == "preview" || ctx.showPreviewPanel ? "block" : "none");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngIf", ctx.maxlength > 0 && ctx.mode != "preview");
        i0.ɵɵadvance();
        i0.ɵɵproperty("ngIf", ctx.options == null ? null : ctx.options.resizable);
      }
    },
    dependencies: [i2.NgIf, MarkdownEditorResizeSensorComponent],
    styles: [".md-editor-container[_ngcontent-%COMP%]{position:relative;height:100%;margin-bottom:15px;border:1px solid rgba(0,0,0,.1)}.md-editor-container.fullscreen[_ngcontent-%COMP%]{margin:0;position:fixed;border:0;top:0;left:0;width:100%!important;height:100%!important;z-index:99999999}.md-editor-container.md-editor-resizable[_ngcontent-%COMP%]:not(.fullscreen){resize:both;overflow:hidden;display:inline-block;width:100%}.md-editor-container.md-editor-resizable[_ngcontent-%COMP%]:not(.fullscreen)   .md-layout[_ngcontent-%COMP%]   .editor-container[_ngcontent-%COMP%]{height:calc(100% - 70px)}.md-editor-container.md-editor-resizable[_ngcontent-%COMP%]:not(.fullscreen)   .md-footer[_ngcontent-%COMP%]{z-index:-1}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]{height:100%;display:flex;flex-direction:column}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .tool-bar[_ngcontent-%COMP%]{background-color:#f5f5f5;border-bottom:1px solid rgba(0,0,0,.1)}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .tool-bar[_ngcontent-%COMP%]   .btn-group[_ngcontent-%COMP%]{padding:6px}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .tool-bar[_ngcontent-%COMP%]   .btn-group[_ngcontent-%COMP%]:first-child:before{display:none}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .tool-bar[_ngcontent-%COMP%]   .btn-group[_ngcontent-%COMP%]:empty{display:none}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .tool-bar[_ngcontent-%COMP%]   .btn-group[_ngcontent-%COMP%]:not(:empty):before{content:\" \";background-color:#a9a9a9;width:1px;height:20px;left:0;top:12px;position:absolute}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .tool-bar[_ngcontent-%COMP%]   .btn-group.hide-split[_ngcontent-%COMP%]:before{display:none}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .tool-bar[_ngcontent-%COMP%]   .btn[_ngcontent-%COMP%]{margin-bottom:0}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .editor-container[_ngcontent-%COMP%]{flex:1;display:flex;height:calc(100% - 100px)}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .editor-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]{flex:1}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .editor-container[_ngcontent-%COMP%] > div[_ngcontent-%COMP%]   .drag-container[_ngcontent-%COMP%]{display:none}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .editor-container[_ngcontent-%COMP%] > div.dragover[_ngcontent-%COMP%]{position:relative;border:2px dashed lightgreen;box-sizing:border-box}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .editor-container[_ngcontent-%COMP%] > div.dragover[_ngcontent-%COMP%]   .drag-container[_ngcontent-%COMP%]{display:block;position:absolute;inset:0;z-index:10;background-color:#0006;display:flex;align-items:center;justify-content:center;font-size:50px;color:#fff}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .editor-container[_ngcontent-%COMP%] > div.dragover[_ngcontent-%COMP%]   .drag-container.drag-container-mask[_ngcontent-%COMP%]{background-color:transparent;z-index:11}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .editor-container[_ngcontent-%COMP%] > div.dragover[_ngcontent-%COMP%]   .drag-container[_ngcontent-%COMP%]   .upload-loading[_ngcontent-%COMP%]{display:flex;flex-direction:column;align-items:center}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .editor-container[_ngcontent-%COMP%] > div.dragover[_ngcontent-%COMP%]   .drag-container[_ngcontent-%COMP%]   .upload-loading[_ngcontent-%COMP%]   .text[_ngcontent-%COMP%]{font-size:20px;margin-top:10px}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .editor-container[_ngcontent-%COMP%]   .editor-panel[_ngcontent-%COMP%]{height:100%}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .editor-container[_ngcontent-%COMP%]   .editor-panel[_ngcontent-%COMP%]   .ace-editor[_ngcontent-%COMP%]{height:100%;min-height:100%}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .preview-container[_ngcontent-%COMP%]{overflow:auto}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .preview-container[_ngcontent-%COMP%]   .preview-panel[_ngcontent-%COMP%]{height:100%;border-left:1px solid rgba(0,0,0,.1);background-color:#fff;padding:10px}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .md-footer[_ngcontent-%COMP%]{background-color:#f0f0f0;border-top:1px solid rgba(0,0,0,.1);display:flex;align-items:center}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .md-footer[_ngcontent-%COMP%]   .length-view[_ngcontent-%COMP%]{flex:1;padding:4px 2px 0;font-size:12px;line-height:16px}.md-editor-container[_ngcontent-%COMP%]   .md-layout[_ngcontent-%COMP%]   .md-footer[_ngcontent-%COMP%]   .resize-btn[_ngcontent-%COMP%]{width:17px}.md-editor-container[_ngcontent-%COMP%]   .pull-right[_ngcontent-%COMP%]{float:right}.md-editor-container[_ngcontent-%COMP%]   .lds-dual-ring[_ngcontent-%COMP%]{display:inline-block;width:80px;height:80px}.md-editor-container[_ngcontent-%COMP%]   .lds-dual-ring[_ngcontent-%COMP%]:after{content:\" \";display:block;width:64px;height:64px;margin:8px;border-radius:50%;border:6px solid #fff;border-color:#fff transparent #fff transparent;animation:_ngcontent-%COMP%_lds-dual-ring 1.2s linear infinite}@keyframes _ngcontent-%COMP%_lds-dual-ring{0%{transform:rotate(0)}to{transform:rotate(360deg)}}"]
  });
  return MarkdownEditorComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let LMarkdownEditorModule = /*#__PURE__*/(() => {
  class LMarkdownEditorModule {}
  LMarkdownEditorModule.ɵfac = function LMarkdownEditorModule_Factory(t) {
    return new (t || LMarkdownEditorModule)();
  };
  LMarkdownEditorModule.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
    type: LMarkdownEditorModule
  });
  LMarkdownEditorModule.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
    imports: [CommonModule, FormsModule]
  });
  return LMarkdownEditorModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { LMarkdownEditorModule, MarkdownEditorComponent, MarkdownEditorResizeSensorComponent };
